module.exports = __webpack_public_path__ + "static/media/DSC05238.65a4ca1b.png";